import { FC, useEffect, useState } from "react";
import {
  BaseGridFilterParameters,
  useBaseGridFilters,
} from "../../BaseGrid/Hooks/useBaseGridFilters";
import { InputDate } from "../../TrueUI";
import { BaseGridFilterOptionsParameter } from "../../BaseGrid/BaseGridProperties";
import { FontsType } from "../../../media/themeTypes";
import { KeysAsType } from "../../../types/KeysAsAType";
import {
  FormattingDate,
  isValidDateByRegex,
} from "../../../utilities/dateFunctions";
import { useGetTableDataForFilter } from "../../../hooks/useGetTableDataForFilter";
import { validateIfInputShouldBeDisabled } from "./FunctionsAgencyPolicies";
type BaseGridExternalDateFilterProps = {
  id?: string;
  options: BaseGridFilterOptionsParameter;
  columnsNames?: string[];
  label?: string;
  defaultValue?: Date | null;
  labelPosition?: "start" | "end" | "top" | "bottom";
  inputWidth?: string;
  labelFontType?: KeysAsType<FontsType>;
  onChangeRawValue?: (e?: any) => void;
  isStaticFilter?: boolean;
  triggerSearchOnBlur?: boolean;
  disableAllDates?: boolean;
  filterName?: string;
};
type BaseGridDateDisabledValidationFilterProperties =
  BaseGridExternalDateFilterProps & {
    tableName: string;
  };
const BaseGridDateDisabledValidationFilter: FC<
  BaseGridDateDisabledValidationFilterProperties
> = ({
  id,
  options,
  columnsNames,
  label,
  defaultValue: propValue,
  labelPosition,
  inputWidth,
  labelFontType,
  onChangeRawValue,
  isStaticFilter,
  triggerSearchOnBlur = false,
  filterName,
  tableName = "",
  disableAllDates = false,
}) => {
  const { useTableDataFromInternalInstance } = useGetTableDataForFilter();

  const filters: BaseGridFilterParameters[] | null =
    useTableDataFromInternalInstance(
      tableName,
      "filterParameters",
      "BaseGridDateDisabledValidationFilter"
    ) ?? null;
  const filterTypeIdValue =
    filters?.find(
      (filter: BaseGridFilterParameters) =>
        filter?.filterId === "agency-policy-filter-type-id"
    ) ?? null;
  const isDisabled = validateIfInputShouldBeDisabled(filterTypeIdValue);
  const disablePast = disableAllDates === true ? isDisabled : false;
  const disableFuture = disableAllDates === true ? isDisabled : false;
  const [_value, _setValue] = useState<Date | null>(propValue ?? null);
  const filterHook = useBaseGridFilters(
    options.uiid ?? "NO_UIID_FOUND",
    {
      filterId: id,
      filterName: filterName ?? "input_date_filter",
      defaultValue: propValue,
      columnNames: columnsNames,
      resetOnManuallyReload: true,
      isStatic: isStaticFilter,
    },
    "BaseGridDateFilter"
  );

  const setDateValueFilter = (value: string) => {
    if (!isStaticFilter) {
      filterHook?.onChange?.(value);
    }
    onChangeRawValue?.(new Date(value));
  };

  useEffect(() => {
    setDateValueFilter(FormattingDate(_value));
  }, []);

  const setValidatedDateValue = (date: any) => {
    _setValue(date);
    if (triggerSearchOnBlur === false && isValidDateByRegex(new Date(date))) {
      setDateValueFilter(FormattingDate(date));
    }
  };

  return (
    <>
      {isDisabled === false && (
        <InputDate
          id={id ?? "filter-input-date-id"}
          name={`filter-input-date-${id}`}
          value={_value}
          label={label}
          labelPosition={labelPosition ?? "start"}
          inputWidth={inputWidth}
          labelFontType={labelFontType ?? "TITLE"}
          onChangeRawValue={(value) => setValidatedDateValue(value)}
          onBlur={(e) => {
            if (
              triggerSearchOnBlur === true &&
              isValidDateByRegex(new Date(e?.target?.value))
            ) {
              setDateValueFilter(FormattingDate(e?.target?.value));
            }
          }}
          disableFuture={disablePast}
          disablePast={disableFuture}
          readOnly={isDisabled}
        />
      )}
    </>
  );
};

export default BaseGridDateDisabledValidationFilter;
